import TopicItemDto from "./topicItemDto";

export default class TopicListItemsDto {
    public limit: number;
    public skip: number;
    public total: number;
    public topicItems: TopicItemDto[];
  
    constructor() {
      this.limit = 0;
      this.skip = 0;
      this.total = 0;

      this.topicItems = [];
    }
  }


// WEBPACK FOOTER //
// ./src/api/topicListItemsDto.ts